import { __awaiter } from "tslib";
import { BaseService } from "../../base";
export class ErrorLogService extends BaseService() {
    static get entity() {
        return "error_log";
    }
    static get responseName() {
        return "error_log";
    }
    /**
     *
     * @param data.user_id
     * @param data.role_id
     * @param data.node_id
     * @param data.page
     */
    static getFilterAll(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `filter_all?page=${data.page}`,
                data: data,
            });
        });
    }
    static create(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `${this.entity}`,
                data: data,
                isFullPath: true,
            });
        });
    }
}
